export default function getCSRFToken() {
    if (!document.cookie) return;

    const token = document.cookie.split(';')
        .map(c => c.trim())
        .filter(c => c.startsWith('csrftoken='));

    if (token.length === 0) return;

    const tokenValue = token[0].split('=')[1];

    if (tokenValue.length === 0) return;

    return decodeURIComponent(tokenValue);
}
